import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { clsx } from 'clsx';
import React__default from 'react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { Typography } from '../../../theme/Typography.es.js';

const root = "_root_6v734_1";
const transition = "_transition_6v734_9";
const styles = {
	root: root,
	transition: transition
};

const TypographyMap = {
  base: "var(--zds-inter)",
  heading: "var(--zds-degular)",
  PageHeader: "var(--zds-page-header)",
  SectionHeader: "var(--zds-section-header)",
  SectionHeaderMultiline: "var(--zds-section-header-multiline)",
  ParagraphHeader4: "var(--zds-paragraph-header-4)",
  ParagraphHeader3: "var(--zds-paragraph-header-3)",
  ParagraphHeader2: "var(--zds-paragraph-header-2)",
  ParagraphHeader1: "var(--zds-paragraph-header-1)",
  Title: "var(--zds-title)",
  Body4: "var(--zds-body-4)",
  Body4Multiline: "var(--zds-body-4-multiline)",
  Body3: "var(--zds-body-3)",
  Body3Multiline: "var(--zds-body-3-multiline)",
  Body2: "var(--zds-body-2)",
  Body2Multiline: "var(--zds-body-2-multiline)",
  Body1: "var(--zds-body-1)",
  Body1Multiline: "var(--zds-body-1-multiline)",
  SmallPrint4: "var(--zds-small-print-4)",
  SmallPrint4Multiline: "var(--zds-small-print-4-multiline)",
  SmallPrint3: "var(--zds-small-print-3)",
  SmallPrint3Multiline: "var(--zds-small-print-3-multiline)",
  SmallPrint2: "var(--zds-small-print-2)",
  SmallPrint2Multiline: "var(--zds-small-print-2-multiline)",
  SmallPrint1: "var(--zds-small-print-1)",
  SmallPrint1Multiline: "var(--zds-small-print-1-multiline)",
  MinimalPrint4: "var(--zds-minimal-print-4)",
  MinimalPrint4Multiline: "var(--zds-minimal-print-4-multiline)",
  MinimalPrint3: "var(--zds-minimal-print-3)",
  MinimalPrint3Multiline: "var(--zds-minimal-print-3-multiline)",
  MinimalPrint2: "var(--zds-minimal-print-2)",
  MinimalPrint2Multiline: "var(--zds-minimal-print-2-multiline)",
  MinimalPrint1: "var(--zds-minimal-print-1)",
  MinimalPrint1Multiline: "var(--zds-minimal-print-1-multiline)"
};
const Text = (_a) => {
  var { className, color = "GrayWarm10", hasTransition = true, style = {}, tag = "span", textAlign = "inherit", type = "Body1" } = _a, otherProps = __rest(_a, ["className", "color", "hasTransition", "style", "tag", "textAlign", "type"]);
  const props = Object.assign({
    color,
    hasTransition,
    tag,
    textAlign,
    type
  }, otherProps);
  return React__default.createElement(props.tag, { className: clsx(className, styles.root, hasTransition && styles.transition), "data-zds": true, style: Object.assign({ "--text-color": Colors[props.color], "--text-margin": props.margin, "--text-text-align": props.textAlign, "--text-font": TypographyMap[type], fontFamily: (type === "base" || type === "heading") && Typography[type].fontFamily, letterSpacing: (type === "PageHeader" || type === "SectionHeader" || type === "SectionHeaderMultiline" || type === "Title") && Typography[type].letterSpacing, fontWeight: props.fontWeight }, style) }, props.children);
};

export { Text };
//# sourceMappingURL=Text.es.js.map
